import React from 'react'

import { useTheme } from 'styled-components/native'

import { CARE_ADVISOR_EMAIL } from '@lyrahealth-inc/shared-app-logic'

import { Link } from './Link'
import { mailTo } from '../../utils'

export type CareNavigatorEmailLinkProps = {
  linkType?: 'error' | 'warning' | 'default'
  underline?: boolean
  text?: string
}

export const CareNavigatorEmailLink: React.FC<CareNavigatorEmailLinkProps> = ({
  linkType = 'error',
  underline = true,
  text = CARE_ADVISOR_EMAIL,
}) => {
  const { colors } = useTheme()

  let color
  if (linkType === 'error') {
    color = colors.textError
  } else if (linkType === 'warning') {
    color = colors.textWarning
  }

  return <Link text={text} onPress={() => mailTo(text || CARE_ADVISOR_EMAIL)} underline={underline} color={color} />
}
